<script>
import { BIconTrash, BIconPencilSquare } from 'bootstrap-vue';
import { firebaseApp } from '../../firebase';
import { mapState } from 'vuex';

export default {
	components: {
		BIconPencilSquare,
		BIconTrash,
	},
	props: {
		newLabel: {
			type: String,
			default: 'Add New Item',
		},
		newLabelForAIGeneration: {
			type: String,
			default: 'Add Clause'
		},
		value: Array,
		label: String,
		objectPrototype: {
			type: Function,
			default: () => {
				return {};
			},
		},
		testid:String,
		hideAddBtn:Boolean,
		isEditView:Boolean,
		itemIndexToShow:Number,
		forceAddNewItem:Boolean,
		disabled:Boolean,
		id:String
},
	methods: {
		add() {
			this.value.push(this.objectPrototype());
			setTimeout(() => {
				let element = this.$refs[this.testid+'list-item']
				const lastElement = element[element.length-1]
				if (lastElement) {
					lastElement.scrollIntoView({ behavior: 'smooth' });
				}
			}, 0);
			
		},
		removeItem(index) {
			if(this.isEditView){
				this.openConfirmModalForDeletion(index);
			} else
			this.value.splice(index, 1);
			if(this.newLabel === "Add Child"){
				this.agreement.parenting.holidayAndSpecialDaysList = this.agreement.parenting.holidayAndSpecialDaysList.filter((holiday)=> holiday.id !== `child${index}'sBirthday`)
			}
		},
		showItemCard(index){
			let result  = false;
			if(this.forceAddNewItem && this.value && this.value.length && (index == (this.value.length-1))){
				result = true;
			} else if(!this.forceAddNewItem && (this.itemIndexToShow == undefined || (this.itemIndexToShow!= undefined && this.itemIndexToShow == index))){
				result = true;
			}
			return result;
		},
		openConfirmModalForDeletion(index) {
			const newElement = this.$createElement;
			const messageConent = newElement(
				'div',
				{ class: ['text-center'] },
				[
					newElement(
						'p',
						{},
						`Are you sure you want to delete this property?
						 The details will be removed from your agreement, agreement builder and property schedule when you take this action.
						 This cannot be undone.`
					),
				]
			);
			this.$bvModal
				.msgBoxConfirm([messageConent], {
					title: 'Are you sure ?',
					size: 'md',
					buttonSize: 'sm',
					okVariant: 'primary',
					okTitle: 'Delete Property',
					cancelTitle: "Cancel",
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true,
				})
				.then((accepted) => {
					if (accepted) {
						this.value.splice(index, 1);
							setTimeout(()=> window.location.reload(true), 1500)

					}
				})
				.catch((err) => {
					console.error('err->',err)
				});
		},
		async submitPrompt(){
			this.textGenerationOptions.responseGenerating = true;
			console.log('this.requestPromptToAI==>',this.textGenerationOptions.requestPromptToAI)
			const createCompletionAPI = firebaseApp.functions('northamerica-northeast1').httpsCallable('openAIApis-createCompletion');
			// const prefixText = 'Using family law agreement sources, write a single legal clause, to be used in an existing agreement. '
			let promptToSend = null
			if(this.textGenerationOptions.isEditMode){
				let previousPrompts = this.value[this.textGenerationOptions.indexToEdit].prompt.map((obj)=>{
					return{
						...obj,
						content : this.prefixText + obj.content
					}
				})
				promptToSend = [...previousPrompts ,{role: 'user',content: this.prefixText + this.textGenerationOptions.requestPromptToAI}]
			}
			else{
				promptToSend = [{role: 'user',content: this.prefixText + this.textGenerationOptions.requestPromptToAI}]
			}
			const reqBody = {
				prompt: promptToSend,
				max_tokens: 400,             
				model: 'gpt-4.1',
				temperature: 0.7,            
				top_p: 1.0,              
				frequency_penalty: 0.1,
				presence_penalty: 0.1,
				// stop: ['\n\n', "The parties agree"]  // Removed "Both parties"
			}
			const linkResponse = await createCompletionAPI(reqBody).catch((err)=> { this.textGenerationOptions.responseGenerating = false; console.error('submitPrompt Error',err)});

			// const createCompletionAPI = firebaseApp.functions('northamerica-northeast1').httpsCallable('openAIApis-fetchAIModels');
			// const linkResponse = await createCompletionAPI().catch((err)=> console.error('submitPrompt Error',err));
			console.log('submitPrompt linkResponse==>',linkResponse)
			
			this.textGenerationOptions.responseGenerating = false;
			if(linkResponse && linkResponse.data && linkResponse.data.choices && linkResponse.data.choices.length){
				let responseContent = linkResponse.data.choices[0].message.content ? linkResponse.data.choices[0].message.content.replace(/\n/g, "") : '';
				responseContent = responseContent.replace(/^["']|["']$/g, '');
				responseContent = responseContent.replace(/^"(.*)"$/s, '$1').replace(/^'(.*)'$/s, '$1');
				//This line is for additional security
				responseContent = responseContent.replace(/^(The parties agree that?|Both parties agree that?|It is agreed that?)\s*/i, '');
				// Stripping the opener above leaves a lower-case first word, so recapitalize last.
				responseContent = responseContent.charAt(0).toUpperCase() + responseContent.slice(1);
				this.textGenerationOptions.responseFromAI = responseContent;
			}
		},
		confirmResponseAndClose(){
			let indexToChange = null;
			if(this.textGenerationOptions.isEditMode){
				indexToChange = this.textGenerationOptions.indexToEdit;

				if(this.value && this.value[indexToChange]){
					this.$set(this.value[indexToChange], 'text', this.textGenerationOptions.responseFromAI);
					this.value[indexToChange].prompt =[...this.value[indexToChange].prompt,{role: 'user', content: this.textGenerationOptions.requestPromptToAI},
					{
						role: 'assistant',
						content: this.textGenerationOptions.responseFromAI
					}]
				}
			} else {
				this.add();
				indexToChange = this.value.length - 1;
				if(this.value && this.value[indexToChange]){
					this.$set(this.value[indexToChange], 'text', this.textGenerationOptions.responseFromAI);
					this.value[indexToChange].prompt =[{role: 'user', content: this.textGenerationOptions.requestPromptToAI},
					{
						role: 'assistant',
						content: this.textGenerationOptions.responseFromAI
					}]
				}
			}
				console.log('responseFromAI-->',this.textGenerationOptions.responseFromAI);
				// console.log(this.value)
				// if(this.value && this.value[indexToChange]){
				// 	this.value[indexToChange].text = this.textGenerationOptions.responseFromAI;
				// 	this.value[indexToChange].prompt = this.textGenerationOptions.requestPromptToAI;
				// }
				console.log('this.value==>',this.value);
				this.textGenerationOptions.showAIGenerationModal = false;
		},
		closeTextGenerationModal(){
			this.textGenerationOptions.showAIGenerationModal = false;
		},
		openTextGenerationModal(options){
			console.log('opt',options)
			this.textGenerationOptions.showAIGenerationModal = true;
			if(options && options.edit){
				this.textGenerationOptions.isEditMode=true;
				if(options.details){
					this.textGenerationOptions.requestPromptToAI = options.details.prompt[options.details.prompt.length - 2].content;
					this.textGenerationOptions.responseFromAI = options.details.text;
				}
				this.textGenerationOptions.indexToEdit = options.index;
			} else {
				this.textGenerationOptions.isEditMode=false;
				this.textGenerationOptions.requestPromptToAI ='';
				this.textGenerationOptions.responseFromAI ='';
			}
		}
	},
	mounted(){
		if(this.forceAddNewItem){
			this.add();
		}
	},
	computed:{
		...mapState(['agreement','currentRoleLevel']),
		isUserSeparatingParty(){
			return this.currentRoleLevel.roleAssociated === 'party'
		},
		textGenerationModalHeading(){
			return (this.textGenerationOptions.isEditMode) ? 'Edit Clause using AI' : 'Generate Clause using AI'
		},
		textGenerationModalSubmitBtn(){
			return (this.textGenerationOptions.isEditMode) ? 'Save the resultant clause' : 'Add the resultant clause' 
		},
		toolTipText(){
			if(this.newLabel === 'Add Child'){
				return 'Click to include additional children.'
			}
			else if(this.newLabel === 'Add Clause'){
				return 'Are there any other important or significant facts that should be outlined about this issue? Add them here - they will be included in the Agreement, verbatim.'
			}
		},
		isMobile() {
			return window.innerWidth <= 768;
		},
		dynamicNewLabel() {
			if (this.isMobile) {
				if (this.newLabel === 'Add Clause to Recitals' || this.newLabel === 'Add Clause to Section') {
					return this.newLabel;
				}
				return this.newLabel.replace('Add Clause', 'Add Clause to Agreement');
			}
			return this.newLabel;
		},
		prefixText() {
			return this.newLabel === 'Add Clause to Section' ? this.agreementPrefixText : this.recitalPrefixText;
		},
		dynamicNewLabelForAIGeneration() {
			let baseLabel;
			if (this.isMobile) {
				if (this.newLabel === 'Add Clause to Recitals' || this.newLabel === 'Add Clause to Section') {
					baseLabel = this.newLabel;
				} else {
					baseLabel = this.newLabel.replace('Add Clause', 'Add Clause to Agreement');
				}
			} else {
				baseLabel = this.newLabel;
			}
			return `${baseLabel}`;
		},
	},
	data(){
		return {
			textGenerationOptions:{
				showAIGenerationModal:false,
				requestPromptToAI :'',
				responseFromAI: '',
				responseGenerating:false,
				isEditMode:false,
				indexToEdit:undefined
			},
			recitalPrefixText: `You are drafting exactly one legal recital for a Canadian Separation Agreement, outlining the facts upon which the Agreements are based.

				The clause must be understandable to a non-lawyer while still meeting professional legal drafting standards.

				This is not an agreement that the parties are making, but a fact upon which the agreements will be based. The recital should be thorough and meet legal language norms.

				There is a general “WHEREAS:” written at the beginning of the section, therefore you do not need to add this language to the beginning of the clause.

				Drafting conventions:
				- Produce exactly one recital, with no heading, numbering or bullet
				- Refer to both spouses as “the parties”
				- Capitalize “Child” and “Children”
				- Capitalize the first letter of the recital`,
			agreementPrefixText: `Write a single legal clause suitable for inclusion in a Canadian Separation Agreement. The clause must be formal, thorough, and legally sound, but written in modern plain language that is understandable by non-lawyers.

				STRICTLY FOLLOW ALL GUIDELINES:

				LANGUAGE REQUIREMENTS:
				- Use formal, clear, modern plain language typical of Canadian legal agreements
				- Do not use archaic or overly technical terms like “shall”, “hereby”, “notwithstanding”, “whereas”, or “aforementioned”
				- Use precise and legally appropriate language that reflects standard drafting practices of Canadian family lawyers
				- Ensure the clause is **detailed, specific, and anticipates reasonable legal and practical scenarios**
				- Make the clause unambiguous and professional, but allow it to be **thorough and expansive** — do not oversimplify

				STRUCTURE AND CONTENT RULES:
				- Do not include a heading
				- Do not begin with phrases like “The parties agree…” — the clause must stand on its own
				- Always specify:
				- Who is responsible for the action
				- What the action is
				- When it occurs (use “When this Agreement is signed,” if timing is not provided)
				- If the clause involves consent or mutual decision-making, explicitly state that “consent will not be unreasonably withheld”
				- Refer to both spouses as “the parties”
				- If referencing Children, always capitalize “Child” or “Children”

				RESTRICTIONS:
				- Only use facts or conditions that are explicitly stated in the user input — do not assume, infer, or expand beyond what is given
				- Do not add numbers, percentages, dates, or timeframes unless clearly stated
				- Do not imply agreement or cooperation between the parties unless explicitly mentioned

				FORMATTING:
				- Capitalize the first letter of the clause
				- Use a professional, court-appropriate tone

				OBJECTIVE:
				Your goal is to produce a clause that sounds like it was drafted by a skilled Canadian family lawyer: **clear, comprehensive, enforceable, and context-aware**.`
		}
	}
};
</script>

<template>
	<fieldset :key="testid+ value.length">
		<legend v-if="label">
			{{ label }}
		</legend>
		<template v-for="(localItem, index) in value">
		<b-card class="mb-3" v-if="showItemCard(index)" :key="index" :id="id+(index+1)" :ref="testid+'list-item'">
			<b-button variant="pastel-blue" size="sm" class="float-right" @click="removeItem(index)" :data-testid="testid+'remove-button'" :disabled="disabled">
				<b-icon-trash />
			</b-button>
			<b-button 
				variant="link" 
				class="p-0 border-0 bg-transparent mb-2 mr-4 float-right" 
				size="lg"
				:disabled="disabled"
				:data-testid="testid+'edit-button'"
				v-if="localItem.prompt"
				@click="openTextGenerationModal({edit:true,details:localItem,index:index})"
			>
				<b-icon-pencil-square variant="info"/>
			</b-button>
			<slot :item="localItem" :index="index" />
		</b-card>
		</template>
		
		<b-button variant="primary" class="add-clause-btn" @click="add" v-if="!hideAddBtn" :data-testid="testid+'add-button'" :disabled="disabled">{{ dynamicNewLabel }}</b-button>
		<b-icon-info-circle class="ml-2"
			v-if="toolTipText && isUserSeparatingParty"
			v-b-tooltip.html="{ title: toolTipText, boundary: 'viewport' }"
		>
		</b-icon-info-circle>
		<b-button variant="primary" class="add-clause-btn-ai" @click="openTextGenerationModal" v-if="!hideAddBtn && (newLabel == 'Add Clause' || newLabel == 'Add Clause to Recitals' || newLabel == 'Add Clause to Section')" :data-testid="testid+'ai-add-button'" :disabled="disabled">{{ dynamicNewLabelForAIGeneration + ` using AI`}}</b-button>


		<b-modal
                id="AIGenerationModal"
                v-model="textGenerationOptions.showAIGenerationModal"
                :title=textGenerationModalHeading
				size="lg"
            >    
                <p>Write the topic or terms you'd like to add to your agreement and we'll convert it into a standard legal clause</p>
				<!-- <b-row>
					<b-col> -->
						<b-form-input
							v-model="textGenerationOptions.requestPromptToAI"
							placeholder="Ex: The parties will share responsibility for the family pets"
							:data-testid="testid +'-request-to-AI'"
						/>
						<b-button size="sm" variant="primary" class="my-2 mt-3" @click="submitPrompt()" data-testid="generate-button" :disabled="textGenerationOptions.responseGenerating || !textGenerationOptions.requestPromptToAI.trim()">
									<template v-if="textGenerationOptions.responseGenerating">
										<b-spinner small type="grow"></b-spinner>
										Generating...
									</template>
									<template v-else>
										Generate
									</template>
						</b-button>
					<!-- </b-col> -->
					<!-- <b-col>
						<b-button size="sm" variant="primary" @click="submitPrompt()" data-testid="cancel-button"> Generate </b-button>
					</b-col>
				</b-row> -->
				<p>Resulting Clause :</p>
					<b-form-textarea
						v-model="textGenerationOptions.responseFromAI"
						class="ml-2 my-3"
						input-cols="6"
						rows="5"
      					max-rows="10"
						:disabled="textGenerationOptions.responseGenerating"
						:data-testid="testid +'-request-from-AI'">
					</b-form-textarea>
                <template #modal-footer="{}">
                    <b-button size="sm" variant="primary" @click="confirmResponseAndClose()" data-testid="add-clause-button" :disabled="textGenerationOptions.responseGenerating || !textGenerationOptions.responseFromAI.trim()"> {{ textGenerationModalSubmitBtn }} </b-button>
                    <b-button size="sm" variant="navy" @click="closeTextGenerationModal()" data-testid="cancel-button"> Cancel </b-button>
                </template>
            </b-modal>
	</fieldset>
</template>

<style scoped>

.bi-pencil-square {
	cursor: pointer;
	transition-duration: 0.5s;
	opacity: 1.0;
}

.add-clause-btn-ai{
	margin-left: 1rem;
}

@media (max-width: 768px) {
    .add-clause-btn-ai{
		margin-top: 0.75rem;
		margin-left: 0;
	}
	.add-clause-btn,.add-clause-btn-ai{
		font-size:0.8rem;
	}
}
</style>